'use client';

import './index.css';

import classnames from 'classnames';
import Spinner from 'react-svg-spinner';

import { Link } from '@/components/link';

import { useInStoryblok } from '@/helpers/client/storyblok';
import { isLink } from '@/helpers/storyblok/is-link';

delete Spinner.defaultProps;

/**
 * @param {object} props - Props for the button.
 * @param {'primary'|'primary-light'|'light-grey'|'white'|'black'|'black-border'|'transparent'|'transparent-primary'|'blue'|'green'|'primary-black'|'full-black'|'glass-white'|'outline-primary'|'outline-white'|'outline-grey'|'text'} props.theme - The theme of the button.
 * @param {'xsmall'|'small'|'normal'|'large'} props.height - The height of the button.
 */
export const Button = ({
  as = 'button',
  link = null,
  impacting = false,
  theme = 'primary',
  height = 'normal',
  leftIcon = undefined,
  rightIcon = undefined,
  loading = false,
  children,
  dangerouslySetInnerHTML,
  disabled = false,
  onClick,
  className = '',
  ...rest
}) => {
  const El = isLink(link) ? Link : as;

  const inStoryblok = useInStoryblok();

  const strange =
    // @ts-ignore
    inStoryblok && El === 'button' && !(rest.onClick || rest.type === 'submit');

  return (
    <div
      className={classnames(
        'button',
        `button--theme-${theme || 'primary'}`,
        `button--height-${height}`,
        {
          'button--has-left-icon': leftIcon,
          'button--has-right-icon': rightIcon,
          'button--impacting': impacting,
          'button--disabled': disabled,
          'button--loading': loading,
        },
        className,
      )}
      style={
        strange
          ? {
              outline: '5px dashed lime',
              outlineOffset: '5px',
            }
          : undefined
      }
    >
      <span className="button__background" />

      <span className="button__content">
        {leftIcon && !loading ? (
          <span className="button__icon">{leftIcon}</span>
        ) : null}

        <El
          className="button__text"
          link={El === Link ? link : null}
          disabled={El === 'button' ? disabled : undefined}
          onClick={onClick}
          {...rest}
          {...(children ? { children } : { dangerouslySetInnerHTML })}
        />

        {rightIcon && !loading ? (
          <span className="button__icon">{rightIcon}</span>
        ) : null}

        <span className="button__spinner">
          <Spinner color="white" speed="fast" size="16" gap={4} thickness={4} />
        </span>
      </span>
    </div>
  );
};
